import TextLink from "hardcover-ui/components/TextLink";
import {
  constantsActive,
  slugConstants,
  slugIdConstants,
} from "types/UserBookStatusType";
import UserBookActivitySnapshot from "types/UserBookActivitySnapshot";

interface StatusLinkProps {
  statusId: number;
  username: string;
  userBook: UserBookActivitySnapshot;
}

export default function StatusLink({
  userBook,
  statusId,
  username,
}: StatusLinkProps) {
  return (
    <p>
      <TextLink
        variant="secondary"
        underline={false}
        size="lg"
        href={`/@${username}/books/${slugConstants[statusId]}`}
      >
        {statusId === slugIdConstants["currently-reading"] &&
        userBook?.progress > 0 ? (
          <>Is {Math.floor(userBook.progress)}% done with</>
        ) : (
          <>{constantsActive[statusId]}</>
        )}
      </TextLink>
    </p>
  );
}
